import React from 'react';
import TableContainer from '../../common/TableContainer';

const EventTable = ({ columns, data = [], loading, limit, currentPage, nextId, prevId, handlePageChange, handlePageSize , hasMore }) => {
  return (
    <div>
      <TableContainer
        data={data}
        loading={loading}
        columns={columns}
        pageSize={limit}
        currentPage={currentPage}
        nextPageToken={nextId}
        prevPageToken={prevId}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePageChange}
        hasMore={hasMore}
      />
    </div>
  );
};

export default EventTable;